import React, {useState} from 'react';
import {useStyles} from './style';
import Fotografias from './Fotografias'
import DatosDelDPI from './DatosDelDPI'

function DatosIdentidad(props) {
    const classes = useStyles();

    return (
        <div style={{margin: '20px 30px'}}>
            <Fotografias datos={props.datos}/>
            <DatosDelDPI datosUbicacion={props.datos?.datosUbicacion} datosDPI={props.datos?.datosDpi}/>
        </div>      
    );
}
export default DatosIdentidad;